import React, { FC } from 'react';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import {
  HeaderText,
  Badge,
  DynamicComponent,
  UniversalLink,
} from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';

const NavTile: FC<TypeAccountNavTileFields> = ({
  title,
  subheader,
  description,
  buttonLink,
  hasDivider,
  badge,
  components,
}) => {
  const hasComponents = components ? components.length > 0 : false;

  const componentClasses = 'lg:flex-1';

  const borderClass = hasDivider
    ? 'border-b-[1px] border-charcoal-opacity-20 mb-5'
    : '';
  return (
    <div
      data-testid="account-nav-tile"
      className="max-w-xl rounded-md p-6 shadow-md"
    >
      {badge && (
        <div className="relative mb-4 flex">
          <Badge {...badge.fields} />
        </div>
      )}
      <div className={borderClass}>
        <div className="grid grid-flow-col grid-rows-1 gap-4">
          <HeaderText
            text={title}
            size={HeaderSize.H3}
            align="left"
            classes="col-span-2 mb-4"
          />
          {buttonLink && (
            <UniversalLink
              link={buttonLink}
              classes="underline lg:text-h4 text-base col-span-1 justify-end mb-4 text-indigo"
            />
          )}
        </div>
        {subheader && <p className="mb-4 text-left leading-6">{subheader}</p>}
      </div>
      {description && <p className="text-left leading-6">{description}</p>}

      {hasComponents &&
        components?.map((component, i) => (
          <div
            key={`${component.sys.id}-${i}`}
            className={`${componentClasses} text-center`}
          >
            <DynamicComponent component={component} />
          </div>
        ))}
    </div>
  );
};

export default React.memo(NavTile);
